import OadpEntityButtonDelete from './oadp-entity-button-delete';
export default OadpEntityButtonDelete;
